import { useEffect, useMemo } from 'react';
import { BsCreditCard2Front } from 'react-icons/bs';
import { IoAddCircle } from 'react-icons/io5';
import { useSelector } from 'react-redux';
import useAxios from '../../../../../axios/useAxios';
import PrimaryButton from '../../../../../components/button/PrimaryButton';
import ChoiceButton from '../../../../../components/buttons/ChoiceButton';
import { FidelityLogger } from '../../../../../hooks/useFidelityLogger';
const CHOICE_OPTIONS = [
  {
    label: 'Créer une carte',
    value: 'create',
    icon: IoAddCircle,
    textColor: 'text-[#4D7534]',
  },
  {
    label: 'Ajouter une carte physique',
    value: 'add',
    icon: BsCreditCard2Front,
    textColor: 'text-black',
  },
];

const InitialChoiceScreen = ({
  onPathSelection,
  choiceValue,
  setChoiceValue,
  isLoading,
  isOneChoicePossible,
  setIsOneChoicePossible,
}) => {
  const user = useSelector((state) => state.user);
  const { store } = useSelector((state) => state.store);
  const axiosInstance = useAxios();
  const fidelityLogger = new FidelityLogger(axiosInstance);

  const CHOICE_OPTIONS = useMemo(() => {
    const hasExistingCard = user?.fidCard?.[0]?.fidelityCardBddId;

    if (hasExistingCard) {
      return [
        {
          label: 'Changer ma carte actuelle',
          value: 'add',
          icon: BsCreditCard2Front,
          textColor: 'text-black',
        },
      ];
    } else {
      return [
        {
          label: 'Créer une carte',
          value: 'create',
          icon: IoAddCircle,
          textColor: 'text-[#4D7534]',
        },
        {
          label: 'Ajouter une carte physique',
          value: 'add',
          icon: BsCreditCard2Front,
          textColor: 'text-black',
        },
      ];
    }
  }, [user?.fidCard]);

  const handleNextClick = () => {
    if (choiceValue === 'create') {
      fidelityLogger.logFidelityCardCreationInitiated(user._id, store._id);
    }
    onPathSelection(choiceValue);
  };
  useEffect(() => {
    if (CHOICE_OPTIONS.length === 1) {
      setIsOneChoicePossible(true);
    }else{
      setIsOneChoicePossible(false)
    }
  }, [setIsOneChoicePossible, CHOICE_OPTIONS]);

  const isNextButtonDisabled = !choiceValue || isLoading;

  return (
    <div className="flex flex-col gap-4 mt-8">
      {CHOICE_OPTIONS.map((choice) => (
        <ChoiceButton
          key={choice.value}
          choice={choice}
          isSelected={choiceValue === choice.value}
          onClick={() => setChoiceValue(choice.value)}
        />
      ))}
      {!isOneChoicePossible && (
        <div className="flex justify-center mt-auto relative bottom-[20px]">
          <PrimaryButton
            onClick={handleNextClick}
            label="Suivant"
            isLoading={isLoading}
            disabled={isNextButtonDisabled}
            className="w-full"
          />
        </div>
      )}
    </div>
  );
};

export default InitialChoiceScreen;
